import { sprintf } from "sprintf-js";

const HOUR_MS = 3_600_000;

export interface CountdownTexts {
  flowersDaysLeft: string;
  flowersHoursLeft: string;
  flowersOneHourLeft: string;
}

/**
 * Time left to order flowers to the ceremony, counted in the browser because the page is
 * cached. Hours up to 48, then whole days, rounded down so it never overpromises. Empty
 * once orders have closed.
 */
export function flowersTimeLeft(
  deadline: string,
  now: Date,
  texts: CountdownTexts
): string {
  const hours = Math.floor((Date.parse(deadline) - now.getTime()) / HOUR_MS);

  if (Number.isNaN(hours) || hours < 0) {
    return "";
  }
  if (hours <= 1) {
    return texts.flowersOneHourLeft;
  }
  if (hours <= 48) {
    return sprintf(texts.flowersHoursLeft, hours);
  }
  return sprintf(texts.flowersDaysLeft, Math.floor(hours / 24));
}
